<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between">
              <h6>商品分類管理</h6>
              <soft-button
                color="success"
                size="sm"
                @click="openModal()"
                v-if="can('product.create')"
              >
                <i class="fas fa-plus me-1"></i> 新增分類
              </soft-button>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      名稱
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Slug
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      排序
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(group, groupName) in groupedCategories"
                    :key="groupName"
                  >
                    <!-- Brand Header Row -->
                    <tr class="bg-light">
                      <td colspan="5" class="py-2 px-3">
                        <h6 class="mb-0 text-dark font-weight-bold">
                          <i class="fas fa-tag me-2"></i>{{ groupName }}
                        </h6>
                      </td>
                    </tr>

                    <template v-for="category in group" :key="category.id">
                      <!-- Parent Category -->
                      <tr>
                        <td>
                          <div class="d-flex px-2 py-1">
                            <div class="d-flex flex-col justify-content-center">
                              <h6 class="mb-0 text-sm">{{ category.name }}</h6>
                            </div>
                          </div>
                        </td>
                        <td>
                          <p class="text-xs font-weight-bold mb-0">
                            {{ category.slug }}
                          </p>
                        </td>
                        <td class="align-middle text-center">
                          <span
                            class="text-secondary text-xs font-weight-bold"
                            >{{ category.sort_order }}</span
                          >
                        </td>
                        <td class="align-middle text-center text-sm">
                          <soft-badge
                            :color="
                              category.is_active ? 'success' : 'secondary'
                            "
                            size="sm"
                          >
                            {{ category.is_active ? "啟用" : "停用" }}
                          </soft-badge>
                        </td>
                        <td class="align-middle">
                          <a
                            href="javascript:;"
                            class="text-info font-weight-bold text-xs me-3"
                            @click="openSortModal(category)"
                            v-if="can('product.edit')"
                          >
                            商品順序
                          </a>
                          <a
                            href="javascript:;"
                            class="text-secondary font-weight-bold text-xs me-3"
                            @click="openModal(category)"
                            v-if="can('product.edit')"
                          >
                            編輯
                          </a>
                          <a
                            href="javascript:;"
                            class="text-danger font-weight-bold text-xs"
                            @click="deleteCategory(category.id)"
                            v-if="can('product.delete')"
                          >
                            刪除
                          </a>
                        </td>
                      </tr>
                      <!-- Child Categories -->
                      <template
                        v-for="child in category.children"
                        :key="child.id"
                      >
                        <tr>
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div
                                class="d-flex flex-col justify-content-center ms-4"
                              >
                                <h6 class="mb-0 text-sm text-secondary">
                                  <i
                                    class="fas fa-level-up-alt fa-rotate-90 me-2"
                                  ></i
                                  >{{ child.name }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p class="text-xs font-weight-bold mb-0">
                              {{ child.slug }}
                            </p>
                          </td>
                          <td class="align-middle text-center">
                            <span
                              class="text-secondary text-xs font-weight-bold"
                              >{{ child.sort_order }}</span
                            >
                          </td>
                          <td class="align-middle text-center text-sm">
                            <soft-badge
                              :color="child.is_active ? 'success' : 'secondary'"
                              size="sm"
                            >
                              {{ child.is_active ? "啟用" : "停用" }}
                            </soft-badge>
                          </td>
                          <td class="align-middle">
                            <a
                              href="javascript:;"
                              class="text-info font-weight-bold text-xs me-3"
                              @click="openSortModal(child)"
                              v-if="can('product.edit')"
                            >
                              商品順序
                            </a>
                            <a
                              href="javascript:;"
                              class="text-secondary font-weight-bold text-xs me-3"
                              @click="openModal(child)"
                              v-if="can('product.edit')"
                            >
                              編輯
                            </a>
                            <a
                              href="javascript:;"
                              class="text-danger font-weight-bold text-xs"
                              @click="deleteCategory(child.id)"
                              v-if="can('product.delete')"
                            >
                              刪除
                            </a>
                          </td>
                        </tr>
                        <!-- Grandchild Categories -->
                        <tr
                          v-for="grandchild in child.children"
                          :key="grandchild.id"
                        >
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div
                                class="d-flex flex-col justify-content-center ms-5 ps-3"
                              >
                                <h6 class="mb-0 text-sm text-muted">
                                  <i
                                    class="fas fa-level-up-alt fa-rotate-90 me-2"
                                  ></i
                                  >{{ grandchild.name }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p class="text-xs font-weight-bold mb-0">
                              {{ grandchild.slug }}
                            </p>
                          </td>
                          <td class="align-middle text-center">
                            <span
                              class="text-secondary text-xs font-weight-bold"
                              >{{ grandchild.sort_order }}</span
                            >
                          </td>
                          <td class="align-middle text-center text-sm">
                            <soft-badge
                              :color="
                                grandchild.is_active ? 'success' : 'secondary'
                              "
                              size="sm"
                            >
                              {{ grandchild.is_active ? "啟用" : "停用" }}
                            </soft-badge>
                          </td>
                          <td class="align-middle">
                            <a
                              href="javascript:;"
                              class="text-info font-weight-bold text-xs me-3"
                              @click="openSortModal(grandchild)"
                              v-if="can('product.edit')"
                            >
                              商品順序
                            </a>
                            <a
                              href="javascript:;"
                              class="text-secondary font-weight-bold text-xs me-3"
                              @click="openModal(grandchild)"
                              v-if="can('product.edit')"
                            >
                              編輯
                            </a>
                            <a
                              href="javascript:;"
                              class="text-danger font-weight-bold text-xs"
                              @click="deleteCategory(grandchild.id)"
                              v-if="can('product.delete')"
                            >
                              刪除
                            </a>
                          </td>
                        </tr>
                      </template>
                    </template>
                  </template>
                  <tr v-if="categories.length === 0">
                    <td colspan="5" class="text-center py-4 text-secondary">
                      暫無資料
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="showModal"
      class="modal fade show d-block"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ form.id ? "編輯分類" : "新增分類" }}</h5>
            <button
              type="button"
              class="btn-close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveCategory">
              <div class="mb-3">
                <label class="form-label">名稱</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.name"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Slug</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.slug"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">父分類</label>
                <select class="form-control" v-model="form.parent_id">
                  <option :value="null">無 (頂層分類)</option>
                  <option
                    v-for="cat in parentCategories"
                    :key="cat.id"
                    :value="cat.id"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">排序</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="form.sort_order"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">品牌 (可選)</label>
                <select class="form-control" v-model="form.brand_id">
                  <option :value="null">無</option>
                  <option
                    v-for="brand in brands"
                    :key="brand.id"
                    :value="brand.id"
                  >
                    {{ brand.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Banner Image</label>
                <input
                  type="file"
                  class="form-control"
                  @change="handleBannerUpload"
                  accept="image/*,.heic,.heif"
                />
                <div
                  v-if="previewBannerUrl"
                  class="mt-2 relative group w-full h-32 bg-gray-100 rounded overflow-hidden"
                >
                  <img
                    :src="previewBannerUrl"
                    class="w-full h-full object-cover"
                  />
                  <button
                    type="button"
                    @click="removeBanner"
                    class="btn btn-sm btn-danger absolute top-2 right-2"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
              <div class="form-check form-switch mb-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="showInMenu"
                  v-model="form.show_in_menu"
                />
                <label class="form-check-label" for="showInMenu"
                  >顯示於選單</label
                >
              </div>
              <div class="form-check form-switch mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="menuExpanded"
                  v-model="form.menu_expanded"
                />
                <label class="form-check-label" for="menuExpanded"
                  >選單預設展開</label
                >
              </div>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="isActive"
                  v-model="form.is_active"
                />
                <label class="form-check-label" for="isActive">啟用</label>
              </div>
              <div class="text-end mt-3">
                <button
                  type="button"
                  class="btn btn-secondary me-2"
                  @click="closeModal"
                >
                  取消
                </button>
                <button type="submit" class="btn btn-success">儲存</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Sort Modal -->
    <div
      v-if="showSortModal"
      class="modal fade show d-block"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              調整產品順序 - {{ selectedCategoryForSort?.name }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="closeSortModal"
            ></button>
          </div>
          <div class="modal-body">
            <CategoryProductSorter
              v-if="selectedCategoryForSort"
              :category-id="selectedCategoryForSort.id"
              @close="closeSortModal"
              @saved="closeSortModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import request from "@/utils/request";
import Swal from "sweetalert2";
import { hasPermission } from "@/utils/permissions";
import CategoryProductSorter from "@/components/CategoryProductSorter.vue";

export default {
  name: "Categories",
  components: {
    SoftButton,
    SoftBadge,
    CategoryProductSorter,
  },
  data() {
    return {
      categories: [],
      brands: [],
      showModal: false,
      showSortModal: false,
      selectedCategoryForSort: null,
      previewBannerUrl: null,
      form: {
        id: null,
        name: "",
        slug: "",
        parent_id: null,
        brand_id: null,
        banner_url: null,
        sort_order: 0,
        is_active: true,
        show_in_menu: true,
        menu_expanded: false,
      },
      currentUser: JSON.parse(localStorage.getItem("user") || "{}"),
    };
  },
  computed: {
    groupedCategories() {
      const groups = {};

      this.categories.forEach((cat) => {
        let groupName = "其他 (Other)";
        if (cat.brand_id) {
          const brand = this.brands.find((b) => b.id === cat.brand_id);
          if (brand) groupName = brand.name;
        }

        if (!groups[groupName]) {
          groups[groupName] = [];
        }
        groups[groupName].push(cat);
      });

      return groups;
    },
    parentCategories() {
      const options = [];
      const traverse = (cats, level = 0) => {
        cats.forEach((c) => {
          // Prevent selecting self as parent
          if (this.form.id && c.id === this.form.id) return;

          // Only allow Level 0 and Level 1 as parents (so max depth is 3)
          if (level < 2) {
            options.push({
              id: c.id,
              name: "- ".repeat(level) + c.name,
            });
            if (c.children) {
              traverse(c.children, level + 1);
            }
          }
        });
      };
      traverse(this.categories);
      return options;
    },
  },
  watch: {
    "form.name": function (newVal) {
      if (!this.form.id && newVal) {
        // Only auto-generate for new categories or if slug is empty
        // Simple slugify: lowercase, replace spaces with dashes
        this.form.slug = newVal
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "");
      }
    },
  },
  created() {
    this.fetchCategories();
    this.fetchBrands();
  },
  methods: {
    can(permission) {
      return hasPermission(this.currentUser, permission);
    },
    async fetchCategories() {
      try {
        const response = await request.get("/api/admin/categories?tree=true");
        this.categories = response.data.data;
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    },
    async fetchBrands() {
      try {
        const response = await request.get("/api/admin/brands");
        this.brands = response.data.data;
      } catch (error) {
        console.error("Failed to fetch brands", error);
      }
    },
    openSortModal(category) {
      this.selectedCategoryForSort = category;
      this.showSortModal = true;
    },
    closeSortModal() {
      this.showSortModal = false;
      this.selectedCategoryForSort = null;
    },
    openModal(category = null) {
      if (category) {
        this.form = {
          ...category,
          is_active: !!category.is_active,
          show_in_menu: !!category.show_in_menu,
          menu_expanded: !!category.menu_expanded,
        };
        this.previewBannerUrl = category.banner_url;
      } else {
        this.form = {
          id: null,
          name: "",
          slug: "",
          parent_id: null,
          brand_id: null,
          banner_url: null,
          sort_order: 0,
          is_active: true,
          show_in_menu: true,
          menu_expanded: false,
        };
        this.previewBannerUrl = null;
      }
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.previewBannerUrl = null;
    },
    async handleBannerUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "category_banner");

      try {
        const response = await request.post("/api/admin/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        this.form.banner_url = response.data.url;
        this.previewBannerUrl = response.data.url;
      } catch (error) {
        console.error("Upload failed", error);
        Swal.fire("錯誤", "圖片上傳失敗", "error");
      }
    },
    removeBanner() {
      this.form.banner_url = null;
      this.previewBannerUrl = null;
    },
    async saveCategory() {
      try {
        if (this.form.id) {
          await request.put(`/api/admin/categories/${this.form.id}`, this.form);
        } else {
          await request.post("/api/admin/categories", this.form);
        }
        this.closeModal();
        this.fetchCategories();
        this.closeModal();
        this.fetchCategories();
        // alert("儲存成功"); // Success is obvious, or use toast
      } catch (error) {
        console.error("Failed to save category", error);
        // Error handled by interceptor
      }
    },
    async deleteCategory(id) {
      Swal.fire({
        title: "確定要刪除此分類嗎？",
        text: "此操作無法復原",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ea0606",
        confirmButtonText: "確定刪除",
        cancelButtonText: "取消",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await request.delete(`/api/admin/categories/${id}`);
            this.fetchCategories();
            Swal.fire("已刪除", "分類已成功刪除。", "success");
          } catch (error) {
            console.error("Failed to delete category", error);
            Swal.fire("錯誤", "刪除分類失敗", "error");
          }
        }
      });
    },
  },
};
</script>
